module.exports = __webpack_public_path__ + "img/call_black.902d7026.svg";